import { z } from "zod";

import { TemplateGroupSchema } from "./TemplateGroup.schema";
import { TemplateVariableSchema } from "./TemplateVariable.schema";

/**
 * Standard template message
 */
export const StandardTemplateMessageSchema = z.object({
  templateId: z.string(),
  name: z.string(),
  description: z.string(),
  variables: z.record(z.string(), TemplateVariableSchema),
  type: z.literal("template").optional(),
  enableMultiLanguage: z.boolean().optional(),
  templateGroup: TemplateGroupSchema.optional()
});
